import { AwayOption } from '../../shared/away-status/away-status.component';

export const TMS_ENDPOINTS = {
  userLogs: {
    signIn:         'api/v1/task-management/user-logs/day/sign-in',
    signOff:        'api/v1/task-management/user-logs/day/sign-off',
    breakStart:     'api/v1/task-management/user-logs/break/start',
    breakEnd:       'api/v1/task-management/user-logs/break/end',
  },
  tasks: {
    list:           'api/v1/task-management/tasks',
  },
  calendar: {
    events:         'v1/api/userMailCalendar/calendarEvents',
  },
} as const;

export const TMS_AWAY_OPTIONS: AwayOption[] = [
  { key: 'lunch',          label: 'Lunch Break',         icon: 'restaurant',     color: '#F59E0B' },
  { key: 'tea',            label: 'Tea / Coffee Break',  icon: 'coffee',         color: '#F59E0B' },
  { key: 'bio',            label: 'Bio Break',           icon: 'wc',             color: '#16A34A' },
  { key: 'phoneCall',      label: 'On a Phone Call',     icon: 'phone',          color: '#16A34A' },
  { key: 'meeting',        label: 'In a Meeting',        icon: 'groups',         color: '#16A34A' },
  { key: 'workshop',       label: 'Workshop / Training', icon: 'present_to_all', color: '#F97316' },
  { key: 'brainstorming',  label: 'Brainstorming',       icon: 'lightbulb',      color: '#FCA5A5' },
  { key: 'clientVisit',    label: 'Client Visit',        icon: 'flight_takeoff', color: '#EF4444' },
  { key: 'wellnessBreak',  label: 'Wellness Break',      icon: 'favorite',       color: '#16A34A' },
  { key: 'codingAndDevelopment',label: 'Coding / Development',    icon: 'code',       color: '#EF4444' },
  { key: 'academicDataAndQuality',label: 'Academic Data & Quality', icon: 'fact_check', color: '#16A34A' },
];

// System-triggered away status — applied automatically when no activity is
// detected on any open tab. Not part of TMS_AWAY_OPTIONS since it must not
// show up as a manually selectable option in the away-status dialog.
export const TMS_INACTIVITY_OPTION: AwayOption = {
  key: 'inactivity', label: 'Away (Inactivity)', icon: 'visibility_off', color: '#6B7280',
};

// Manually triggered away (header "Away" button) — the break/start call no
// longer takes a break type, so — same as TMS_INACTIVITY_OPTION — the specific
// type isn't known until the user resumes and picks one from the reason grid.
export const TMS_MANUAL_AWAY_OPTION: AwayOption = {
  key: 'away', label: 'Away', icon: 'schedule', color: '#6B7280',
};

// Break types that don't need an additional free-text reason when picked on
// resume (see AwayLockComponent.selectReason) — every other type, "Other"
// included, does.
export const TMS_NO_REASON_REQUIRED_KEYS: string[] = [
  'lunch', 'tea', 'bio', 'wellnessBreak', 'codingAndDevelopment',
];

// How long the app waits, with no activity on any open tab, before auto-locking.
export const TMS_IDLE_TIMEOUT_MS = 5 * 60 * 1000;